import React, { useState, useEffect } from "react";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Row
} from "antd";
import {
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules
} from "../element/FormItems";
import { compose } from "recompose";
import withSort from "../element/HOC/withSort";
import CustomSelect from "../element/CustomSelect";
import withData from "../element/withData";
import country from "../country";
import currency from "../currency";
import moment from "moment";
import PhoneCountryComponent from "./PhoneCountryComponent";
import {useTranslation} from "react-i18next";

function Vendor(props) {
  const { getFieldDecorator, setFieldsValue, getFieldValue } = props.form;
  const { submit, submitting, host, isMondiale, isMMEA, isSouter, isClearFog } = props;

  const [isAccountContactSameAsRep, setIsAccountContactSameAsRep] = useState(
    false
  );
  const [isCoordinatorContactSameAsRep, setIsCoordinatorSameAsRep] = useState(
    false
  );

  const { t } = useTranslation();

    useEffect(() => {
        setFieldsValue({ 'registeredAddress.country': 'ML' })
    }, [setFieldsValue])


    const Label = ({ text }) => (
    <div
      style={{
        fontSize: "1.714rem",
        margin: "1em 0em 0.5em 0em"
      }}
    >
      {text}
    </div>
  );

  const CountrySelect = compose(
    withData({ data: country }),
    withSort
  )(CustomSelect);

  const CurrencySelect = compose(
    withData({ data: currency }),
    withSort
  )(CustomSelect);


  console.log(getFieldValue('bank.country'))
  return (
      <Form>
        <Label text={t('form.vendor.bankTitle')} />

        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.registeredName')}>
              {getFieldDecorator("business.registeredName", {
                rules: rules.input
              })(<Input placeholder={t('form.vendor.registeredName')} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.tradingName')}>
              {getFieldDecorator("business.tradingName")(
                  <Input placeholder={t('form.vendor.tradingName')} />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.registrationNo')}>
              {getFieldDecorator("business.registrationNo")(
                  <Input placeholder={t('form.vendor.registrationNo')} />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
                {...defaultFormItemLayout} label={t('form.vendor.taxNo')}>
              {getFieldDecorator("business.taxNo")(
                  <Input placeholder={t('form.vendor.taxNo')} />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.dunsNo')}>
              {getFieldDecorator("business.dunsNo")(
                  <Input placeholder={t('form.vendor.dunsNo')} />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Divider />

        <Label text={t('form.vendor.registeredAddress')} />
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.country')}>
              {getFieldDecorator("registeredAddress.country", {
                rules: rules.input
              })(<CountrySelect placeholder={t('form.vendor.country')} logoAtr={"Unicode"} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.address1')}>
              {getFieldDecorator("registeredAddress.address.line1", {
                rules: rules.input
              })(<Input placeholder={t('form.vendor.address1')} />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.address2')}>
              {getFieldDecorator("registeredAddress.address.line2")(
                  <Input placeholder={t('form.vendor.address2')} />
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.city')}>
              {getFieldDecorator("registeredAddress.city", {
                rules: rules.input
              })(<Input placeholder={t('form.vendor.city')} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
                {...defaultFormItemLayout}
                label={t('form.vendor.state')}
            >
              {getFieldDecorator("registeredAddress.state", {
              })(<Input placeholder={t('form.vendor.state')} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.postcode')}>
              {getFieldDecorator("registeredAddress.postcode", {
              })(<Input placeholder={t('form.vendor.postcode')} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <PhoneCountryComponent
              {...{
                form: props.form,
                phonePath: "registeredAddress.telephoneNo",
                  phoneName: t('telephoneNo')
              }}
          />

          <PhoneCountryComponent
              {...{
                form: props.form,
                phonePath: "registeredAddress.faxNo",
                  phoneName: t('faxNo')
              }}
          />
        </Row>
        <Divider />

          <Label text={t('form.vendor.bankAccount')} />
          <Row>
              <Row>
                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={t('form.bank.accountName')}>
                          {getFieldDecorator("bank.accountName", {
                              rules: rules.input
                          })(<Input placeholder={t('form.bank.accountName')} />)}
                      </Form.Item>
                  </Col>
                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={t('form.bank.currency')}>
                          {getFieldDecorator("bank.currency", {
                              rules: rules.input
                          })(<CurrencySelect placeholder={t('form.bank.currency')} />)}
                      </Form.Item>
                  </Col>
                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={t('form.bank.bankName')}>
                          {getFieldDecorator("bank.bankName", {
                              rules: rules.input
                          })(<Input placeholder={t('form.bank.bankName')} />)}
                      </Form.Item>
                  </Col>
                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={t('form.bank.branchName')}>
                          {getFieldDecorator("bank.branchName", {
                              rules: rules.input
                          })(<Input placeholder={t('form.bank.branchName')} />)}
                      </Form.Item>
                  </Col>
                  <Col span={24}>
                      <Form.Item {...fullWidthFormItemLayout} label={t('form.bank.address')}>
                          {getFieldDecorator("bank.address", {
                              rules: rules.input
                          })(<Input placeholder={t('form.bank.address')} />)}
                      </Form.Item>
                  </Col>

                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={t('form.bank.country')}>
                          {getFieldDecorator("bank.country", {
                              rules: rules.input
                          })(<CountrySelect placeholder="Country" keyAtr={'value'} logoAtr={"Unicode"} />)}
                      </Form.Item>
                  </Col>
                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={t('form.bank.accountNumber')}>
                          {getFieldDecorator("bank.accountNumber", {
                              rules: rules.input
                          })(<Input placeholder={t('form.bank.accountNumber')} />)}
                      </Form.Item>
                  </Col>
                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={"IBAN"}>
                          {getFieldDecorator("bank.iban", {
                          })(<Input placeholder="IBAN" />)}
                      </Form.Item>
                  </Col>
                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={"Swift Code"}>
                          {getFieldDecorator("bank.swiftCode", {
                          })(<Input placeholder="Swift Code" />)}
                      </Form.Item>
                  </Col>
                  {getFieldValue('bank.country') === 'United Kingdom' && (<Col span={12}>
                      <Form.Item
                          {...defaultFormItemLayout}
                          label={isMondiale || isMMEA ? "ABA/BSB/SORT" : "SORT Code"}
                      >
                          {getFieldDecorator("bank.otherCode", {
                              rules: rules.input
                          })(
                              <Input placeholder={isMondiale || isMMEA ? "ABA/BSB/SORT" : "SORT Code"} />
                          )}
                      </Form.Item>
                  </Col>)}
              </Row>
              <Row>
                  <div style={{ fontSize: "1.3rem", margin: "0.5em 0em" }}>
                      Intermediary Bank
                  </div>

                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={t('form.bank.bankName')}>
                          {getFieldDecorator("intermediaryBankDetail.bankName")(
                              <Input placeholder={t('form.bank.bankName')} />
                          )}
                      </Form.Item>
                  </Col>
                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={t('form.bank.branchName')}>
                          {getFieldDecorator("intermediaryBankDetail.branchName")(
                              <Input placeholder={t('form.bank.branchName')} />
                          )}
                      </Form.Item>
                  </Col>
                  <Col span={24}>
                      <Form.Item {...fullWidthFormItemLayout} label={t('form.bank.address')} >
                          {getFieldDecorator("intermediaryBankDetail.address")(
                              <Input placeholder={t('form.bank.address')}  />
                          )}
                      </Form.Item>
                  </Col>
                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={t('form.bank.country')}>
                          {getFieldDecorator("intermediaryBankDetail.country")(
                              <CountrySelect logoAtr={"Unicode"} keyAtr={'value'} placeholder="Country" />
                          )}
                      </Form.Item>
                  </Col>
                  <Col span={12}>
                      <Form.Item {...defaultFormItemLayout} label={"Swift Code"}>
                          {getFieldDecorator("intermediaryBankDetail.swiftCode")(
                              <Input placeholder="Swift Code" />
                          )}
                      </Form.Item>
                  </Col>
                  {getFieldValue('intermediaryBankDetail.country') === 'United Kingdom' &&   <Col span={12}>
                      <Form.Item
                          {...defaultFormItemLayout}
                          label={isMondiale || isMMEA ? "ABA/BSB/SORT" : "SORT Code"}
                      >
                          {getFieldDecorator("bank.otherCode", {
                              rules: rules.input
                          })(
                              <Input placeholder={isMondiale || isMMEA ? "ABA/BSB/SORT" : "SORT Code"} />
                          )}
                      </Form.Item>
                  </Col>}
              </Row>
              </Row>
        <Divider />

        <Label text={t('form.vendor.salesRep')} />
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.name')}>
              {getFieldDecorator("representativeContact.name", {
                rules: rules.input
              })(<Input placeholder={t('form.vendor.name')} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.position')}>
              {getFieldDecorator("representativeContact.position", {
                rules: rules.input
              })(<Input placeholder={t('form.vendor.position')} />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.email')}>
              {getFieldDecorator("representativeContact.email", {
                rules: rules.input
              })(<Input placeholder={t('form.vendor.email')} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {/*<Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={"Country"}>
            {getFieldDecorator("representativeContact.country", {
              rules: rules.input
            })(<CountrySelect placeholder="Country" logoAtr={"Unicode"} />)}
          </Form.Item>
        </Col>*/}
          <PhoneCountryComponent
              {...{
                form: props.form,
                phonePath: "representativeContact.telephoneNo"
              }}
          />

          <PhoneCountryComponent
              {...{
                form: props.form,
                phonePath: "representativeContact.mobileNo",
                phoneName:  t('telephoneNo')
              }}
          />
        </Row>

        <Divider />

        <Label text={t('form.vendor.accountsContact')} />
        <Row>
          <Col span={12}>
            <Form.Item
                {...defaultFormItemLayout}
                label={t('form.vendor.accountRepSameAsSalesRep')}
            >
              {getFieldDecorator("accounts.isSameAsRep")(
                  <Checkbox
                      onChange={({ target }) =>
                          setIsAccountContactSameAsRep(target.checked)
                      }
                  />
              )}
            </Form.Item>
          </Col>
        </Row>
        {!isAccountContactSameAsRep && (
            <>
              <Row>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={t('form.vendor.name')}>
                    {getFieldDecorator("accounts.name")(
                        <Input placeholder={t('form.vendor.name')} />
                    )}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={t('form.vendor.position')}>
                    {getFieldDecorator("accounts.position")(
                        <Input placeholder={t('form.vendor.position')} />
                    )}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={t('form.vendor.email')}>
                    {getFieldDecorator("accounts.email")(
                        <Input placeholder={t('form.vendor.email')} />
                    )}
                  </Form.Item>
                </Col>

                {/*<Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={"Country"}>
                {getFieldDecorator("accounts.country")(
                    <CountrySelect placeholder="Country" logoAtr={"Unicode"} />
                )}
              </Form.Item>
            </Col>*/}
              </Row>

              <Row>
                <PhoneCountryComponent
                    {...{
                      form: props.form,
                      phonePath: "accounts.telephoneNo"
                    }}
                />

                <PhoneCountryComponent
                    {...{
                      form: props.form,
                      phonePath: "accounts.mobileNo",
                      phoneName:  t('telephoneNo')
                    }}
                />
              </Row>
            </>
        )}
        <Divider />

        <Label text={t('form.vendor.shippingTitle')} />
        <Row>
          <Col span={12}>
            <Form.Item
                {...defaultFormItemLayout}
                label={t('form.vendor.accountRepSameAsSalesRep')}
            >
              {getFieldDecorator("coordinator.isSameAsRep")(
                  <Checkbox
                      onChange={({ target }) =>
                          setIsCoordinatorSameAsRep(target.checked)
                      }
                  />
              )}
            </Form.Item>
          </Col>
        </Row>

        {!isCoordinatorContactSameAsRep && (
            <>
              <Row>
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={t('form.vendor.name')}>
                    {getFieldDecorator("coordinator.name")(
                        <Input placeholder={t('form.vendor.name')} />
                    )}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={t('form.vendor.position')}>
                    {getFieldDecorator("coordinator.position")(
                        <Input placeholder={t('form.vendor.position')} />
                    )}
                  </Form.Item>
                </Col>

                {/*<Col span={12}>
                <Form.Item {...defaultFormItemLayout} label={"Country"}>
                  {getFieldDecorator("coordinator.country")(
                      <CountrySelect placeholder="Country" logoAtr={"Unicode"} />
                  )}
                </Form.Item>
              </Col>*/}

                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label={t('form.vendor.email')}>
                    {getFieldDecorator("coordinator.email")(
                        <Input placeholder={t('form.vendor.email')} />
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <PhoneCountryComponent
                    {...{
                      form: props.form,
                      phonePath: "coordinator.telephoneNo"

                    }}
                />

                <PhoneCountryComponent
                    {...{
                      form: props.form,
                      phonePath: "coordinator.mobileNo",
                      phoneName:  t('telephoneNo')
                    }}
                />
              </Row>
            </>
        )}
        <Divider />

        <Label text={t('form.vendor.privacyNotice')} />
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.name')}>
              {getFieldDecorator("dataPrivacyNoticeAcknowledgement.name", {
                rules: rules.input
              })(<Input placeholder={t('form.vendor.email')} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('form.vendor.position')}>
              {getFieldDecorator("dataPrivacyNoticeAcknowledgement.position", {
                rules: rules.input
              })(<Input placeholder={t('form.vendor.email')} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={"Date"}>
              {getFieldDecorator("dataPrivacyNoticeAcknowledgement.date", {
                initialValue: moment(),
                rules: rules.select
              })(<DatePicker disabled style={{ width: "100%" }} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
        <span
            style={{
              margin: "20px 0px",
              display: "block",
              fontWeight: 300,
              maxWidth: "700px!important",
              fontSize: "1.14rem"
            }}
        >

            {t('form.vendor.privacyNoticeDescription')}
          <a href="https://rms.africa/privacy">https://rms.africa/privacy</a>
        </span>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={t('agree')}>
              {getFieldDecorator("dataPrivacyNoticeAcknowledgement.hasAgreed", {
                rules: rules.input
              })(<Checkbox placeholder={t('agree')} />)}
            </Form.Item>
          </Col>
        </Row>
        <Button
            on
            type={"primary"}
            icon={"plus"}
            loading={submitting}
            onClick={submit}
        >
          Submit
        </Button>
      </Form>
  );
}

export default Form.create()(Vendor);
